/* One shared, native Shopify enquiry drawer across the storefront. */
(() => {
  'use strict';
  const t = (text, params) => window.LRSI18n?.t(text, params) ?? String(text).replace(/\{(\w+)\}/g, (match, key) => params && Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match);
  if (window.LRSCommissionDrawer) return;
  const instances = new Map(), rails = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => !reduced.matches && document.body.dataset.lrsMotion !== 'false';
  const path = value => window.LRSI18n?.routePath(value) || value.replace(/\/+$/, '') || '/';
  const contactURL = () => document.querySelector('[data-commission-global], [data-commission-cards]')?.dataset.commissionUrl || document.querySelector('.header-cta')?.getAttribute('href') || (window.LRSI18n?.url('/pages/contact') || '/pages/contact');
  const details = link => {
    const url = new URL(link.href, location.href);
    return {model:link.dataset.commissionModel || url.searchParams.get('model') || url.searchParams.get('vehicle') || '', title:link.dataset.commissionTitle || url.searchParams.get('title') || '', advance:false};
  };
  function focusStep(root) {
    const target = root.querySelector('[data-contact-success], [data-contact-errors]') || root.querySelector('[data-contact-step]:not([hidden])');
    target?.focus({preventScroll:true});
  }
  function init(scope = document) {
    const globals = [...scope.querySelectorAll('[data-commission-global]')];
    if (scope.matches?.('[data-commission-global]')) globals.unshift(scope);
    globals.forEach(section => {
      if (instances.has(section)) return;
      const drawer = section.querySelector('[data-commission-drawer]'), root = drawer?.querySelector('[data-lrs-contact]');
      if (!root || typeof drawer.showModal !== 'function') return;
      const controller = new AbortController();
      const on = (node,event,fn,options={}) => node.addEventListener(event,fn,{...options,signal:controller.signal});
      let opener = null, closing = false, previousOverflow = '', animation = null;
      function open(source,selection={}) {
        closing = false; animation?.cancel(); animation = null;
        const menu = document.querySelector('#site-menu'), menuOpen = !!menu?.open;
        const fromMenu = !!source?.closest('#site-menu');
        opener = fromMenu ? document.querySelector('.menu-toggle') : source || document.activeElement;
        if (menuOpen) menu.close();
        if (!drawer.open) {
          // The navigation may have closed earlier in this same click event.
          previousOverflow = menuOpen || fromMenu ? '' : document.body.style.overflow;
          drawer.showModal(); document.body.style.overflow = 'hidden';
        }
        root.dispatchEvent(new CustomEvent('lrs:commission:reset'));
        if (selection.model) root.dispatchEvent(new CustomEvent('lrs:commission:select',{detail:selection}));
        requestAnimationFrame(() => {if (drawer.open) focusStep(root);});
      }
      function close() {
        if (!drawer.open || closing) return;
        closing = true;
        if (motion() && typeof drawer.animate === 'function') {
          animation = drawer.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}],{duration:220,easing:'cubic-bezier(.4,0,1,1)'});
          animation.finished.then(() => {drawer.close(); animation = null; closing = false;}).catch(() => {closing = false;});
        } else {drawer.close(); closing = false;}
      }
      const state = {section,drawer,root,open,controller}; instances.set(section,state);
      on(drawer,'click',event => {
        if (event.target.closest('[data-commission-close]')) {close(); return;}
        const r = drawer.getBoundingClientRect();
        if (event.target === drawer && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) close();
      });
      on(drawer,'cancel',event => {event.preventDefault(); close();});
      on(drawer,'close',() => {
        if (!document.querySelector('dialog[open]')) document.body.style.overflow = previousOverflow;
        const target = opener?.isConnected && !opener.closest('dialog:not([open])') ? opener : document.querySelector('.header-cta');
        target?.focus({preventScroll:true});
      });
      on(root,'lrs:commission:status',() => {if (!drawer.open) open(null);});
      if (root.querySelector('[data-contact-success], [data-contact-errors]')) open(null);
    });
    const cards = [...scope.querySelectorAll('[data-commission-cards]')];
    if (scope.matches?.('[data-commission-cards]')) cards.unshift(scope);
    cards.forEach(section => {
      if (rails.has(section)) return;
      const rail = section.querySelector('[data-commission-rail]'), controls = section.querySelector('.lrs-commission-card-controls');
      const prev = section.querySelector('[data-commission-prev]'), next = section.querySelector('[data-commission-next]');
      if (!rail || !controls || !prev || !next) return;
      const controller = new AbortController(); rails.set(section,controller);
      const on = (node,event,fn,options={}) => node.addEventListener(event,fn,{...options,signal:controller.signal});
      controls.hidden = false;
      const update = () => {prev.disabled = rail.scrollLeft < 3; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;};
      const move = direction => rail.scrollBy({left:direction * ((rail.querySelector('.lrs-commission-card')?.offsetWidth || rail.clientWidth * .82) + 18),behavior:motion() ? 'smooth' : 'auto'});
      on(prev,'click',() => move(-1)); on(next,'click',() => move(1));
      on(rail,'scroll',update,{passive:true}); on(window,'resize',update,{passive:true}); update();
    });
    const state = [...instances.values()].find(item => item.section.isConnected);
    if (state) document.querySelectorAll('a[href]').forEach(link => {
      try {
        const url = new URL(link.href,location.href), target = new URL(contactURL(),location.href);
        if (url.origin === location.origin && path(url.pathname) === path(target.pathname) && !link.closest('[data-commission-drawer]')) {
          link.setAttribute('aria-haspopup','dialog'); link.setAttribute('aria-controls',state.drawer.id);
        }
      } catch { /* Other navigation retains its native behaviour. */ }
    });
  }
  document.addEventListener('click',event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.closest('[data-commission-drawer]')) return;
    let url,target;
    try {url = new URL(link.href,location.href); target = new URL(contactURL(),location.href);} catch {return;}
    if (url.origin !== location.origin || path(url.pathname) !== path(target.pathname)) return;
    const state = [...instances.values()].find(item => item.section.isConnected);
    const inline = !state && document.querySelector('main [data-lrs-contact]');
    if (!state && !inline) return;
    event.preventDefault(); const selection = details(link);
    if (state) state.open(link,selection);
    else {
      inline.dispatchEvent(new CustomEvent('lrs:commission:reset'));
      if (selection.model) inline.dispatchEvent(new CustomEvent('lrs:commission:select',{detail:selection}));
      inline.scrollIntoView({behavior:motion() ? 'smooth' : 'auto',block:'start'});
      requestAnimationFrame(() => focusStep(inline));
    }
  });
  function unload(scope) {
    for (const [section,state] of instances) if (scope === section || scope.contains(section)) {
      if (state.drawer.open) state.drawer.close(); state.controller.abort(); instances.delete(section);
    }
    for (const [section,controller] of rails) if (scope === section || scope.contains(section)) {controller.abort(); rails.delete(section);}
  }
  window.LRSCommissionDrawer = {init,unload};
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => unload(event.target));
  document.addEventListener('shopify:section:select',event => {
    const state = [...instances.values()].find(item => event.target === item.section || event.target.contains(item.section));
    if (state) state.open(null);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(),{once:true}); else init();
})();
